<template>
  <div class="MethodOpisBlockEdit">
    <div class="VisBt"></div>
    <div class="EditBt Add" @click.prevent="updateOpisData"></div>
    <div class="MMarkers">
      <span v-for="tag in tags">
        <img class="MP" :src="`/img/fpc-${tag.id}.png`" v-show="!tagSelected(tag.id)" @click="addTag(tag.id)">
        <img class="MP" :src="`/img/fpk-${tag.id}.png`" v-show="tagSelected(tag.id)" @click="removeTag(tag.id)">
      </span>
    </div>
    <div class="MyIconBt Add" @click="addToFavorites" v-show="authorized && !isFavoriteCard(card)"></div>
    <div class="MyIconBt Remove" @click="removeFromFavorites" v-show="authorized && isFavoriteCard(card)"></div>
    <div class="MMName">{{ card.name_big }}</div>
    <form @submit.prevent="updateOpisData">
      <input type="text" class="MVNameE" name="name_small" value="Доп. название" v-model="card.name_small">
      <input type="text" class="MPeopleE" name="people" value="Количество участников" v-model="card.people">
      <input type="text" class="MHoursE" name="time" value="Сколько часов" v-model="card.time">
      <textarea maxlength='120' class='MIBlockE' name='announcement' v-model="card.announcement"></textarea>
    </form>
    <!-- <div class="MObnovlenie"></div> -->
  </div>
</template>

<script>
import { pick, remove } from 'lodash';
import { API_ROOT } from "@/utils/api_root";
import { mapGetters } from 'vuex';

export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    saveDataColumns: Function,
    saveDataParams: Function,
    toggleAction: Function,
  },
  // data() {
  //   return {
  //   };
  // },
  methods: {
    addTag(tagId) {
      this.card.tag_ids.push(tagId);
      this.card.tag_ids.sort();
    },
    removeTag(tagId) {
      this.card.tag_ids = this.card.tag_ids.filter(e => e !== tagId);
    },
    tagSelected(tagId) {
      // console.log('tagSelected', tagId, this.card.tag_ids, this.card.tag_ids.includes(tagId));
      return this.card.tag_ids.includes(tagId);
    },
    updateOpisData() {
      // console.log('Card component toggleAction', this.toggleAction);
      this.saveDataColumns(['name_small', 'people', 'time', 'announcement', 'tag_ids'], this.toggleAction);
    },
    addToFavorites() {
      this.$http.put(`${API_ROOT}/users/${this.currentUser.id}/favorite_cards/${this.card.id}.json`)
        .then(response => {
          // this.flash('Роль сохранена', 'success', {timeout: 3000});
            this.currentUser.favorite_card_ids = response.data;
            console.log('addToFavorites response.data', response.data);
        })
        .catch(error => {
          console.log('addToFavorites error', error, error.response);
          this.flash('Ошибка сохранения', 'error');
          // this.cardOpisErrors = error.response.data;
        });
    },
    removeFromFavorites() {
      this.$http.delete(`${API_ROOT}/users/${this.currentUser.id}/favorite_cards/${this.card.id}.json`)
        .then(response => {
          // this.flash('Роль сохранена', 'success', {timeout: 3000});
            console.log('removeFromFavorites response.data', response.data);
            this.currentUser.favorite_card_ids = response.data;
        })
        .catch(error => {
          console.log('addToFavorites error', error, error.response);
          this.flash('Ошибка сохранения', 'error');
          // this.cardOpisErrors = error.response.data;
        });
    },
    isFavoriteCard(card) {
      return this.currentUser.favorite_card_ids.includes(card.id);
    },
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized', 'tags']),
  }
};
</script>

<style>




</style>
